import { useParams } from "react-router";

import { colors } from "theme/palette";

import DealAvatar from "components/DealAvatar";
import Paper from "components/Paper";
import Stack from "components/Stack";
import Text from "components/Text";

import { useDealDetails } from "entities/Deal/sdk";
import { useMemoDealDetails } from "entities/Memo/sdk";

const MemoHeader = () => {
  const params = useParams<{
    memoId: string;
    dealId: string;
  }>();
  const memoId = Number(params.memoId);
  const dealId = Number(params.dealId);

  const { data: deal } = useDealDetails({ dealId });

  const { data: memo } = useMemoDealDetails({
    dealId,
    memoId,
  });

  return (
    <Paper
      sx={{
        backgroundColor: colors.blue10,
        borderRadius: 0,
      }}
      data-testid="memo-header-section"
    >
      <Stack direction="row" spacing={2}>
        <DealAvatar
          src={deal?.thumbnail}
          imgix
          imgixWidth={480}
          imgixHeight={240}
          sx={{ width: "240px", height: "120px", objectFit: "cover" }}
        />
        <Stack>
          <Text
            variant="label"
            sx={{ color: colors.blue100 }}
            data-testid="memo-name"
          >
            {memo?.name}
          </Text>
          <Text variant="h1" data-testid="header-section-deal-name">
            {deal?.name}
          </Text>
        </Stack>
      </Stack>
    </Paper>
  );
};

export default MemoHeader;
